import { i18n } from "@/locales/index.js";
import store from "@/store/";

// ER-162 on relance les ventes !
// If sales are blocked again, do not forget to uncomment "allow: true" in router\index.js
export default async ({ from, to, next }) => {
//   let allowRoutes = ['PersonalDetails', 'Agent', 'PriceIncrease'];
//
//   if(!store.state.subscription.agentCustomId && !store.getters['contract/anyProduct']) {
//     if(allowRoutes.indexOf(to.name) < 0 && to.meta.allow == undefined) {
//       return next(`/${i18n.locale}/price-increase`, {query: to.query});
//     }
//   }
}


// WEBPACK FOOTER //
// ./src/router/middleware/blockCustomers.js